export default [
  {
    text: 'Comprador',
    value: 'comprador',
    width: '250px',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Razão Social',
    value: 'razao_social',
    width: '250px',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Produto',
    value: 'descricao_produto',
    width: '250px',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Excesso',
    value: 'excesso',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Adequado',
    value: 'adequado',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Baixa Exposição',
    value: 'baixa_exposicao_ruptura',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Elevada Exposição',
    value: 'elevada_exposicao_ruptura',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Ruptura',
    value: 'ruptura',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Estoque',
    value: 'estoque',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Id Pedido Trânsito',
    value: 'lista_pedidos_em_aberto',
    width: '250px',
    align: 'center',
    class: 'text-center border-right-table-multifiliais',
    cellClass: 'text-center border-right-table-multifiliais'
  },
  {
    text: 'Ações',
    value: 'opcoes',
    width: '25px'
  }
];
